import { type TFunction } from "i18next";
import { z } from "zod";

export const approveSchema = (t: TFunction, showAnchorageAreaSelect: boolean) =>
  z.object({
    files: z.any().optional(),
    internalNotes: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.internal-notes"),
          max: 1000,
        }),
      )
      .optional(),
    externalNotes: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.external-notes"),
          max: 1000,
        }),
      )
      .optional(),
    ...(showAnchorageAreaSelect
      ? {
          assignedAnchorageArea: z.string().min(
            1,
            t("form-validation.mandatory", {
              label: t("vessel-call.approve.assigned-anchorage-area"),
            }),
          ),
        }
      : {}),
  });

export type ApproveSchema = z.infer<ReturnType<typeof approveSchema>>;
